/**
 * 训练模块接口列表
 */
import { post, get } from '../http'; // 导入http中创建的axios实例
export const train = {
    // 添加训练任务
    addTrain(params) {
        return post(`${process.env.VUE_APP_BASE_API}/train/add`, params);
    },
    // 给某训练任务添加学员
    addTrainStu(params) {
        return post(`${process.env.VUE_APP_BASE_API}/train/addStu`, params);
    },
    // 删除训练任务学员
    deleteTrainStudent(params) {
        return post(`${process.env.VUE_APP_BASE_API}/train/delete/student/${params.trainId}/${params.studentId}`);
    },

    // 新建任务
    addTaskApi(params) {
        return post(`${process.env.VUE_APP_BASE_API}/task/info/addTask`, params);
    },
    // 当天训练的学员

    getCurrentTrainStu(params) {
         let data = {
            currentDay: params.currentDay
        }
        return get(`${process.env.VUE_APP_BASE_API}/train/date/stu/${params.trainId}`, data);
    },

    // 获取学员任务
    getStudentTask(params) {
        return get(`${process.env.VUE_APP_BASE_API}/task/info/stu/${params.studentId}/${params.trainId}?currentDay=${params.currentDay}`);
    },

    // 学员任务 评分
    studentTaskRate(params) {
        return post(`${process.env.VUE_APP_BASE_API}/task/info/updateStatus`, params);
    },

    // 完成训练
    doneTrain(trainId) {
        return post(`${process.env.VUE_APP_BASE_API}/train/completed/${trainId}`);

    },
    // 同步任务
    syncTask(params) {
        let data = {
            trainId: params.trainId,
            studentIds: params.studentIds,
            currentDay: params.currentDay
        }
        return post(`${process.env.VUE_APP_BASE_API}/task/info/syncTask/${params.selectStuId}`, data);
    },
    // 同步任务获取学员
    getSyncTaskStu(currentDay) {
        return get(`${process.env.VUE_APP_BASE_API}/task/info/stu/list?currentDay=${currentDay}`);
    },
    // 删除训练
    deleteTrain(params) {
        return post(`${process.env.VUE_APP_BASE_API}/train/delete/${params}`);
    },
    // 获取训练详情
    getTrainInfo(id) {
        return get(`${process.env.VUE_APP_BASE_API}/train/${id}`);
    },
    // 编辑训练
    editTrain(params) {
        return post(`${process.env.VUE_APP_BASE_API}/train/update`, params);
    },
    //删除学员任务信息 
    deleteStudentTask(params) {
        return post(`${process.env.VUE_APP_BASE_API}/task/info/delete/${params.studentId}/${params.id}`);
    },
    // 获取任务详情
    getTaskInfo(id) {
        return get(`${process.env.VUE_APP_BASE_API}/task/info/${id}`);
    },
    // 编辑任务详情
    editTaskInfo(params) {
        return post(`${process.env.VUE_APP_BASE_API}/task/info/update`, params);
    },
    // 获取任务类型
    getTaskFunc(pid) {
        return get(`${process.env.VUE_APP_BASE_API}/task/config/parent/${pid}`);
    },
    // 获取学员日报
    getStudentDay(params) {
        return get(`${process.env.VUE_APP_BASE_API}/train/report/${params.studentId}?currentDate=${params.currentDate}`);
    },
    // 日报图表
    getStudentDayChart(params) {
        return get(`${process.env.VUE_APP_BASE_API}/train/report/chart/${params.studentId}?dateRange=${params.dateRange}`);
    },
    // 生成日报
    createStudentDay(trainId) {
        return post(`${process.env.VUE_APP_BASE_API}/train/report/generateTask/${trainId}`);
    },
}


